import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, Subject, of, race } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { GlobalQuestionService } from './global-question.service';
import { RouterLinks } from '../constants';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class ClaimGuardService {

  guardState$ = new Subject<any>();
  continueClicked$ = new Subject<void>();
  cancelClicked$ = new Subject<void>();

  constructor(
    private globalQuestionService: GlobalQuestionService,
    private router: Router,
    private storageService: StorageService
  ) {}

  /**
   * navigateOnCancel: when true (default) cancelling the guard navigates to
   * previous-document-page. Pages that trigger the guard from their own context
   * (policy detail pages, lists) pass false so the user simply stays put.
   */
  startClaimFlow(policy_id: string, class_id: number, item_id: number, vaps_id: number, person_id: number = 0, navigateOnCancel: boolean = true): Observable<any> {
    return this.globalQuestionService.getClaimsSuperflow(policy_id, class_id, item_id, vaps_id, person_id).pipe(
      switchMap(result => this.handleGuard(result, policy_id, class_id, item_id, vaps_id, person_id, navigateOnCancel))
    );
  }

  private handleGuard(result: any, policy_id: string, class_id: number, item_id: number, vaps_id: number, person_id: number, navigateOnCancel: boolean): Observable<any> {
    if (result?.[0]?.has_initiated_claim) {
      this.guardState$.next(result[0]);
      return race(
        this.continueClicked$.pipe(
          take(1),
          switchMap(() => this.globalQuestionService.cancelClaim(result[0].initiated_claim_session_id)),
          switchMap(() => this.globalQuestionService.getClaimsSuperflow(policy_id, class_id, item_id, vaps_id, person_id))
        ),
        this.cancelClicked$.pipe(
          take(1),
          switchMap(() => {
            if (navigateOnCancel) {
              const previousDocumentPage = this.storageService.get('previous-document-page', 'flow');
              this.router.navigate([previousDocumentPage ? previousDocumentPage : `/${RouterLinks.ClaimsLanding}`]);
            }
            return EMPTY;
          })
        )
      );
    }
    return of(result);
  }
}
